/**
 * Where the rail's date tap should scroll to. Tapping a day does not filter the list — it moves
 * the reader to the right place in a list that still shows everything upcoming.
 */
export type DateJumpTarget = { kind: 'day'; key: string } | undefined;

/**
 * Resolves the tap on `dateKey` against what is actually rendered: the day's block when the list
 * has one. A campaign now sits under every day it runs, so a lit day has a block of its own —
 * unless the active category pills filtered it away while the rail still lights it (the
 * uncategorised pill is not a server category, so the rail over-lights for it).
 *
 * `undefined` when there is nothing to scroll to; the caller leaves the list where it is rather
 * than jumping somewhere arbitrary.
 */
export function resolveDateJump(dateKey: string, renderedDayKeys: readonly string[]): DateJumpTarget {
  return renderedDayKeys.includes(dateKey) ? { kind: 'day', key: dateKey } : undefined;
}
